import { emitSeoTrackingEvent, KycVerificationSuccessEvent } from 'nexchange-service/module/seo'

const emitSeoEventOnKycVerificationSuccess = (): void => {
    emitSeoTrackingEvent(new KycVerificationSuccessEvent())
}

export { emitSeoEventOnKycVerificationSuccess }
